import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, Typography, Space, Tag, Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { EntityImage } from '../Entities/EntityImage';
import { useSubscription } from '../../hooks/use_subscription';
import { useApi } from '../../hooks/use_api';
import ChangePassword from './ChangePassword';
import Credits from './Credits';
import LinkedAccounts from './LinkedAccounts';
import ActiveSessions from './ActiveSessions';
import AgentTokens from './AgentTokens';
import DeleteAccount from './DeleteAccount';

const { Title, Text } = Typography;

function Account() {
    const { isDarkMode } = useTheme();
    const api = useApi();
    // The same avatar as the navbar's "me" button: their uploaded picture, or
    // the generated one. Null until AuthContext has found their person entity.
    const { userPersonEntity } = useAuth();
    const logoSrc = isDarkMode ? '/white_outline.svg' : '/black_outline.svg';
    const subscription = useSubscription();
    const [profile, setProfile] = useState({ name: '', email: '' });
    const userId = localStorage.getItem('id');

    useEffect(() => {
        if (!userId) return;
        api.get(`/api/users/${userId}/profile`)
            .then(data => {
                if (data) setProfile({ name: data.name || '', email: data.email || '' });
            })
            .catch(err => console.error('Error fetching profile:', err));
    }, [userId]);

    const displayName = profile.name || localStorage.getItem('name');
    const displayEmail = profile.email || localStorage.getItem('username');

    return (
        <div style={{ margin: 20, maxWidth: 720 }}>
            <Card>
                <Space align="start" size={16}>
                    {userPersonEntity ? (
                        <Tooltip title="Your profile — change your picture there">
                            <Link to={`/entity/${userPersonEntity.id}`} style={{ flexShrink: 0, lineHeight: 0 }}>
                                <EntityImage entity={userPersonEntity} size={48} />
                            </Link>
                        </Tooltip>
                    ) : (
                    <div style={{
                        width: 48,
                        height: 48,
                        borderRadius: '50%',
                        background: 'var(--bg-secondary)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 22,
                        color: 'var(--text-secondary)',
                        flexShrink: 0,
                    }}>
                        <UserOutlined />
                    </div>
                    )}
                    <div>
                        <Space align="center" style={{ marginBottom: 2 }}>
                            <Title level={4} style={{ margin: 0 }}>{displayName}</Title>
                            {subscription.is_subscriber && (
                                <Tag color="gold" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                    <img src={logoSrc} alt="" style={{ width: 10, height: 10 }} />Subscriber
                                </Tag>
                            )}
                        </Space>
                        <div><Text type="secondary">{displayEmail}</Text></div>
                    </div>
                </Space>
            </Card>

            <Credits />
            <ActiveSessions />
            <AgentTokens />
            <ChangePassword />
            <LinkedAccounts />

            <DeleteAccount />
        </div>
    );
}

export default Account;
